import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { generatePageWithTabsRoute } from './routeGenerator';
import { smartMetersRouteDefinitions } from './SmartMetersRouteDefinitions';

const SmartMetersRoutes: RouteObject = generatePageWithTabsRoute(
  'Identify hard-to-find issues with interval data',
  BASE.SMART_METERS,
  NESTED_ROUTES.SMART_METERS.HOURLY,
  smartMetersRouteDefinitions,
);

export default SmartMetersRoutes;
